var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEraser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1924 4.4144L8.65682 7.94993L16.435 15.7281L19.9705 12.1926C20.7516 11.4115 20.7516 10.1452 19.9705 9.36415L15.0208 4.4144C14.2397 3.63335 12.9734 3.63335 12.1924 4.4144ZM4.41284 15.0197L9.2084 10.206L7.79152 8.79441L2.99596 13.6081C2.21743 14.3896 2.21862 15.6539 2.99863 16.4339L5.68626 19.1215C6.24887 19.6841 7.01193 20.0002 7.80758 20.0002H10.9164C11.7155 20.0002 12.4816 19.6814 13.0447 19.1144L15.5734 16.5689L14.1545 15.1594L11.6258 17.7049C11.4381 17.8939 11.1827 18.0002 10.9164 18.0002H7.80758C7.54236 18.0002 7.28801 17.8948 7.10047 17.7073L4.41284 15.0197Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEraser);
export default __webpack_public_path__ + "static/media/eraser.eb4e39e3.svg";
export { ForwardRef as ReactComponent };